module.exports = "<div id=\"search-component\">\n  <h4>Doctor Search</h4>\n  <input #searchBox id=\"search-box\" autocomplete=\"off\" (keyup)=\"search(searchBox.value)\" />\n  <div *ngIf=\"!hide\">\n    <div *ngFor=\"let user of users | async\" (click)=\"gotoDetail(user)\" class=\"search-result\" >\n    {{user.lastName}},{{user.firstName}}\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/doctors/search/doctor-search.component.html
// module id = 1107
// module chunks = 1